// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachmentName__Y8OUTISOvJ{flex-grow:1}.scrollContainer__qzItOclD_T{max-height:250px;overflow:auto}`, "",{"version":3,"sources":["webpack://./src/assets/components/shared/util/richTextField/components/components/attachmentsFieldList/attachmentsFieldList.module.scss"],"names":[],"mappings":"AAAA,4BACE,WAAA,CAGF,6BACE,gBAAA,CACA,aAAA","sourcesContent":[".attachmentName {\n  flex-grow: 1;\n}\n\n.scrollContainer {\n  max-height: 250px;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachmentName": `attachmentName__Y8OUTISOvJ`,
	"scrollContainer": `scrollContainer__qzItOclD_T`
};
export default ___CSS_LOADER_EXPORT___;
